import classNames from 'classnames';
import * as df from 'date-fns';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksCheckInput, { InputType } from '../../model1/forms/BooksCheckInput';
import BooksOutlineLabel from '../labels/BooksOutlineLabel';

import css from './BooksDateTimePicker.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  postable: boolean;
  checked: boolean;
  date: string;
  startTime: string;
  endTime: string;
  onChange: (e: React.ChangeEvent) => void;
  vacancy: number;
  showVacancy: boolean;
  attendees: number;
  waitingListProvided: boolean;
  setNotification?: boolean;
  onClickSetNotification?: (e: React.MouseEvent) => void;
}

const BooksDateTimePicker = ({
  className,
  postable,
  checked,
  date,
  startTime,
  endTime,
  intl,
  onChange,
  value,
  vacancy,
  showVacancy,
  attendees,
  waitingListProvided,
  setNotification,
  onClickSetNotification,
}: Props & InjectedIntlProps) => {
  const classes = classNames(css.BooksDateTimePicker, className);
  const dateClasses = classNames(
    css.BooksDateTimePicker__Date,
    vacancy < attendees || vacancy < 1 ? css.isDisabled : '',
  );
  const notificationClasses = classNames(
    css.BooksDateTimePicker__Notification,
    css.isSetNotification,
  );
  const labelClasses = classNames(
    css.BooksDateTimePicker__Label,
    { [css.isSoldOut]: !vacancy },
    className,
  );

  return (
    <div className={classes}>
      <BooksCheckInput
        value={value}
        type={InputType.Checkbox}
        checked={checked}
        name="books-date-time-picker"
        onChange={onChange}
        labelClassName={css.BooksDateTimePicker__Input}
        disabled={vacancy < attendees || vacancy < 1}
      >
        <div className={dateClasses}>
          {intl.formatDate(df.format(date), {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short',
          })}
          <span className={css.BooksDateTimePicker__Time}>
            {startTime}
            <span> - </span>
            {endTime}
          </span>
        </div>
        <div className={css.BooksDateTimePicker__Labels}>
          {vacancy > attendees ? (
            showVacancy && (
              <BooksOutlineLabel
                label={`${intl.formatMessage({
                  id: 'merchants.services.status.vacancy',
                })} ${vacancy}`}
                className={css.BooksDateTimePicker__Label}
              />
            )
          ) : vacancy < 1 ? (
            <BooksOutlineLabel
              label={intl.formatMessage({
                id: 'merchants.services.status.soldOut',
              })}
              className={labelClasses}
            />
          ) : (
            showVacancy && (
              <BooksOutlineLabel
                label={`${intl.formatMessage({
                  id: 'merchants.services.status.vacancy',
                })} ${vacancy}`}
                className={css.BooksDateTimePicker__Label}
              />
            )
          )}
          {setNotification
            ? vacancy < 1 &&
              waitingListProvided && (
                <span className={notificationClasses}>
                  {intl.formatMessage({
                    id: 'books.notification.notificationSet',
                  })}
                </span>
              )
            : vacancy < 1 &&
              waitingListProvided && (
                <button
                  type="button"
                  value={value}
                  disabled={!postable}
                  className={css.BooksDateTimePicker__Notification}
                  onClick={onClickSetNotification}
                >
                  {intl.formatMessage({ id: 'books.notification.getNotified' })}
                  {!postable && (
                    <span className={css.BooksDateTimePicker__Loading} />
                  )}
                </button>
              )}
        </div>
      </BooksCheckInput>
    </div>
  );
};

export default injectIntl(BooksDateTimePicker);
